import { useQuery } from "@tanstack/react-query";
import { DepartmentService } from "../../../../../services/lookup-data/department.service";
import { useCallback, useMemo } from "react";

export const docDepartmentKeys = {
  all: "doc-departments",
};

const handleSelect = (r: any) => {
  return r.map((e: any) => ({ ...e, key: e.Id }));
};

export const useDocDepartments = () => {
  const { data, isLoading } = useQuery({
    queryKey: [docDepartmentKeys.all],
    queryFn: () => DepartmentService.getList(),
    select: (r: any) => handleSelect(r),
  });

  const getDepartmentsByDocType = useCallback(
    (docType?: string) => {
      if (!data) return [];
      if (!docType) return data;
      return data.filter((e: { docType: string[] }) => e.docType.includes(docType));
    },
    [data],
  );

  const departmentsTreeData = useMemo(() => {
    if (!data) return [];
    var parents = data.filter((d: any) => !d.CompanyId);

    const result = parents.map((p: any) => {
      const item = { ...p };
      const children = data.filter((d: any) => d.CompanyId === p.Id);
      return {
        ...item,
        children: [...children],
      };
    });

    return result;
  }, [data]);

  return { data, departmentsTreeData, isLoading, getDepartmentsByDocType };
};
